import React from 'react';

export const Sales = () => {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold text-gray-900 mb-6">Track Sales</h1>
      <div className="bg-white rounded-lg shadow-sm p-6">
        <p className="text-gray-500">Sales tracking functionality coming soon...</p>
      </div>
    </div>
  );
};